// Central place for brand-specific Dialog UI overrides used by ThemedDialog
// Shape is merged into the Material-UI theme via useClientTheme()

// Example result used by ThemedDialog:
// {
//   cmDialog: {
//     borderRadius: 20,
//     // closeIconComponent: CustomIcon, // optional
//   }
// }

import CloseIcon from './images/close.svg';
import CloseWhiteIcon from './images/close-white.svg';

export const getDialogOverrides = brand => {
  switch ((brand || '').toLowerCase()) {
    case 'benovo':
      return {
        cmDialog: {
          borderRadius: 10,
        },
      };
    case 'intermountainhealth':
    case 'intermountainhealth-uat':
    case 'intermountaineap':
      return {
        cmDialog: {
          borderRadius: 20,
          closeIconComponent: CloseIcon,
          closeIconComponentAlt: CloseWhiteIcon,
          closeButton: { top: 8, right: 8 },
        },
        cmDialogMobile: {
          borderRadius: 8,
          closeIconComponent: CloseIcon,
          closeIconComponentAlt: CloseWhiteIcon,
          closeButton: { top: 0, right: 0 },
        },
      };
    default:
      return {};
  }
};

export default getDialogOverrides;
